import type { GuardAppEnvironment } from './types';
import { env as ip4xEnv } from './ip4x';

/**
 * Guard NOC on IP4X staging (IP4X-Staging, deploy/staging/README.md): the production `ip4x` build
 * pointed at staging's own core and region. Served from `dist/ip4x-staging` at
 * `*.guard.staging.ip4x.systems`; each `{slug}.guard.staging.ip4x.systems` resolves its tenant via
 * Core `/resolve-domain`, which needs `guard.staging.ip4x.systems` in BASE_DOMAINS.
 */
export const env: GuardAppEnvironment = {
  ...ip4xEnv,
  buildMode: 'ip4x-staging',
  apiBaseUrl: 'https://api.staging.ip4x.systems/v1',
  coreApiUrl: 'https://core-api.staging.ip4x.systems/v1',
  portalBaseUrl: 'https://guard.staging.ip4x.systems',
};
